import { render, staticRenderFns } from "./RasmusUserForm.vue?vue&type=template&id=46a04f45&"
import script from "./RasmusUserForm.vue?vue&type=script&lang=ts&"
export * from "./RasmusUserForm.vue?vue&type=script&lang=ts&"
import style0 from "./RasmusUserForm.vue?vue&type=style&index=0&lang=postcss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports